import React, { useState, useRef } from "react";
import { Spinner } from "../components/Layout";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AlertTitle from '@mui/material/AlertTitle';
import { log } from "../Helper";
import { toast } from "react-toastify";
import _ from "lodash";
import { Alert} from "../components/Alert";
import { getAccessToken } from "../utils/okta-config";
import { API_ROOT } from "../constants/constants";
import { Button } from "@deere/fuel-react";
import { CostFileUpload } from "./CostFileUpload";

const Cost = (props) => {
  const [isSelected, setIsSelected] = useState(false);
  // const [selectedFile, setSelectedFile] = useState();
  const [excelErrorMsg, setExcelErrorMsg] = useState();
  const [excelParsingError, setExcelParsingError] = useState();
  let [openLoader, setOpenLoader] = useState(false);
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [rejectedFiles, setRejectedFiles] = useState([]);
  // const [isFileSelected, setIsFileSelected] = useState(false);

  let isSubmitDisabled = useRef(false);

  const handleCloseLoader = () => {
    setOpenLoader(false);
  };

  const handleDrop = (acceptedFiles, fileRejections) => {
    setExcelParsingError(false);
    setExcelErrorMsg("");
    setAcceptedFiles(acceptedFiles);
    setRejectedFiles(fileRejections);
    // setIsFileSelected(true);
    setIsSelected(true);
    log("files", acceptedFiles);
  };

  const resetFileUpload = () => {
    setAcceptedFiles([]);
    setRejectedFiles([]);
    setIsSelected(false);
  };

  const handleSubmission = () => {
    if (isSubmitDisabled.current) {
      return;
    }

    isSubmitDisabled.current = true;

    if (isSelected === true && acceptedFiles.length > 0) {
      setOpenLoader(true);
      const formData = new FormData();

      for (let i = 0; i < acceptedFiles.length; i++) {
        formData.append("File", acceptedFiles[i]);
      }

      let url = `${process.env.REACT_APP_API_ENDPOINT}/document/upload/cost`;
      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
        },
      };

      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          log("Success: ", result);
          if (result.statusCode === 0) {
            toast.error(result.message);
          } else if (result.statusCode === 1) {
            toast.success(result.message);
          } else if (result.statusCode === 2) {
            toast.warn("Incomplete cost date uploaded.");
            setExcelErrorMsg(
              _.concat(
                result.message,
                ". All other cost date uploaded successfully"
              )
            );
            setExcelParsingError(true);
          }
          handleCloseLoader();
          setIsSelected(false);
          isSubmitDisabled.current = false;
          resetFileUpload();
        })
        .catch((error) => {
          console.error("Error: ", error);
          isSubmitDisabled.current = false;
          resetFileUpload();
        });
    } else {
      if (acceptedFiles.length === 0 && rejectedFiles.length === 0) {
        toast.error("No file selected");
      } else if (acceptedFiles.length === 0 && rejectedFiles.length != 0) {
        toast.error("Please choose a valid file.");
      } else toast.info("Please choose the file again with correct data.");
      isSubmitDisabled.current = false;
      resetFileUpload();
    }
  };

  return (
    <>
      <div className="fileUpload m-[1%] p-[2%] w-[80%] md:w-[50%] lg:w-[40%] xl:w-[40%] 2xl:w-[30%] border-2 border-gray-400">
        <label className="text-sm">
          Please upload the file to update the cost
        </label>
        <br />
        <br />
        <div>
          <CostFileUpload
            onDrop={handleDrop}
            acceptedFiles={acceptedFiles}
            fileRejections={rejectedFiles}
          />
          <div className="center mt-6">
            <Button
              id="cost-submit-btn"
              variant="primary"
              onClick={handleSubmission}
              disabled={acceptedFiles.length <= 0}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
      <div>
        {excelParsingError ? (
          <Alert
            accessibilityLabel="Warning:"
            type="warning"
            aria-atomic="true"
            sx={{
              fontSize: 16,
              "& .MuiAlert-icon": { fontSize: 25 },
              py: 2,
              px: 6,
            }}
          >
            <AlertTitle>Incorrect Data found</AlertTitle>
            <p className="uxf-alert-description text-sm">{excelErrorMsg}.</p>
          </Alert>
        ) : null}
        <Dialog
          open={openLoader}
          onClose={handleCloseLoader}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title"></DialogTitle>
          <DialogContent>
            <div className="d-flex w-100 justify-content-center align-items-center">
              <Spinner
                accessibilityLabel="Loading"
                className="uxf-spinner-border-lg"
                animation="border"
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default Cost;
